import client from "../services/feathers"
// import axios from 'axios';

export const setCodesOTP = async (id, state, service = 'codes') => {
    try {
        await client.service(service).patch(id, {state })
        // console.log(user)
        return Promise.resolve({ message: 'Estado modificado', type: 'success'})
    } catch (error) {
        //console.log('error de findUserService',JSON.stringify(error))
        return Promise.reject({ message: 'El estado no pudo ser modificado', type: 'error'})
        // return Promise.reject(error);
    }
    
}


export const getDeviceIp = async () => {
    return new Promise( async function(resolve, reject) {
        try {
            
            //const responseIp = await axios.get("https://jsonip.com/", {timeout : 600000})

            resolve("Sin Ip")

        } catch (error) {
            resolve("Sin Ip")
        }
    })
}

export const openLink = (link) => {
    try {
        window.open(link);
    } catch (error) {
        
    }
}